// Config for OMT_GameMessageScheduler

// priority: Lower number = more important
// -1 = transcendent priority: These exist outside the normal priority hierarchy, only one of each type can be scheduled at any given time
// enabled_bot: can be sent as bot message
// enabled_a2u: can be sent as app-to-user notification
// limitPerSession: how many times can the message be sent per session
// templateType: template type for A2U
// media: url to image or video used in A2U
// params: default parameters for A2U. [myUserId] is replaced by the actual user id at init time. Null parameters must be filled in at send time.

export const messageConfig = {
  FullLives: {
    priority: 1,
    enabled_bot: true,
    enabled_a2u: true,
    limitPerSession: Infinity,
    templateType: 'ITEM_STATUS',
    media: 'full_lives.png',
    params: {
      item: 'lives',
      status: 'fully refilled',
      is_plural: true,
    },
  },
  HourlyGift: {
    priority: 2,
    enabled_bot: true,
    enabled_a2u: true,
    limitPerSession: Infinity,
    templateType: 'REWARD_READY',
    media: 'hourly_gift.png',
    params: {
      reward: '3-hour gift',
      is_plural: false,
    },
  },
  GateOpen: {
    priority: 3,
    enabled_bot: true,
    enabled_a2u: true,
    limitPerSession: Infinity,
    templateType: 'NEW_ATTEMPTS',
    media: 'gate_open.png',
    params: {
      features: 'unlocked gate',
      is_plural: false,
    },
  },
  ResetWheel: {
    priority: 4,
    enabled_bot: true,
    enabled_a2u: true,
    limitPerSession: Infinity,
    templateType: 'REWARD_READY',
    media: 'reset_wheel.png',
    params: {
      reward: 'daily free spin',
      is_plural: false,
    },
  },
  DailyMis: {
    priority: 5,
    enabled_bot: false,
    enabled_a2u: false,
    limitPerSession: Infinity,
    templateType: 'DAILY_CHALLENGE',
    media: 'daily_missions_reset.png',
    params: {},
  },
  DailyChallenge: {
    priority: 5,
    enabled_bot: false,
    enabled_a2u: true,
    limitPerSession: Infinity,
    templateType: 'DAILY_CHALLENGE',
    media: 'daily_challenge_reset.png',
    params: {},
  },
  DailReward: {
    priority: 6,
    enabled_bot: true,
    enabled_a2u: true,
    limitPerSession: Infinity,
    templateType: 'REWARD_READY',
    media: 'daily_rewards.png',
    params: {
      reward: 'daily reward',
      is_plural: false,
    },
  },
  PlayerPassed: {
    priority: -1,
    enabled_bot: false,
    enabled_a2u: true,
    limitPerSession: 1,
    templateType: 'PLAYER_REACHED_LEVEL',
    media: 'player_passed.png',
    params: {
      player_id: '[myUserId]',
      level: null,
    },
  },
  ScoreBeaten: {
    priority: -1,
    enabled_bot: false,
    enabled_a2u: true,
    limitPerSession: 1,
    templateType: 'SCORE_PASSED',
    media: 'score_beaten.png',
    params: {
      player_id: '[myUserId]',
    },
  },
  SentGift: {
    priority: -1,
    enabled_bot: false,
    enabled_a2u: true,
    limitPerSession: Infinity,
    templateType: 'PLAYER_SENT_GIFT',
    media: 'sent_gift.png',
    params: {
      player_id: '[myUserId]',
      item: null,
    },
  },
  FriendshipChestClaimed: {
    priority: -1,
    enabled_bot: false,
    enabled_a2u: true,
    limitPerSession: Infinity,
    templateType: 'PLAYER_PLAYING_CLAIM_REWARD',
    media: 'friendship_chest_claimed.png',
    params: {
      player_id: '[myUserId]',
    },
  },
};

// Colours for console messages
export const colours = {
  ok: '#80A0FF',
  warning: '#FFFFA0',
  error: '#FF8080',
};
